export const ar: Record<string, string> = {
  // عام
  'common.signIn': 'تسجيل الدخول',
  'common.signOut': 'تسجيل الخروج',
  'common.getStarted': 'ابدأ الآن',
  'common.createAccount': 'إنشاء حساب',
  'common.language': 'اللغة',
  'common.loading': 'جارٍ التحميل…',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ',
  'common.back': 'رجوع',

  // التنقل
  'nav.connections': 'الاتصالات',
  'nav.contacts': 'جهات الاتصال',
  'nav.inbox': 'الرسائل',
  'nav.followUps': "المتابعة الذكية",
  'nav.insights': "تحليل العملاء",
  'nav.chatAnalysis': "تحليل المحادثات بالـ AI",
  'nav.autoReplies': "الردود التلقائية",
  'ar.title': "الردود التلقائية",
  'ar.subtitle': "رد على العملاء أوتوماتيك: المنيو، المواعيد، التوصيل، اللوكيشن، تغيير الرقم…",
  'ar.add': "إضافة رد تلقائي",
  'ar.galleryTitle': "اختار نموذج جاهز للمطعم",
  'ar.blank': "رد فاضي",
  'ar.blankHelp': "اكتب ردك من الأول",
  'ar.empty': "مافيش ردود تلقائية لسه. ابدأ من نموذج جاهز وعدّله.",
  'ar.pickTemplate': "اختار نموذج",
  'ar.newTitle': "رد تلقائي جديد",
  'ar.editTitle': "تعديل الرد التلقائي",
  'ar.name': "الاسم",
  'ar.trigger': "يرد إمتى؟",
  'ar.trigger.ANY': "على أي رسالة العميل يبعتها",
  'ar.trigger.FIRST_MESSAGE': "على أول رسالة من عميل جديد",
  'ar.trigger.OUTSIDE_HOURS': "لما المطعم يكون قافل",
  'ar.trigger.KEYWORDS': "لما الرسالة يكون فيها كلمات معينة",
  'ar.when.ANY': "بيرد على أي رسالة",
  'ar.when.FIRST_MESSAGE': "بيرد على أول رسالة من عميل جديد",
  'ar.when.OUTSIDE_HOURS': "بيرد لما المطعم قافل (المواعيد {from} ← {to})",
  'ar.when.KEYWORDS': "بيرد لما يكتب: {words}",
  'ar.keywords': "الكلمات اللي تشغّله",
  'ar.keywordsHelp': "افصل بينهم بفاصلة. الاختلافات في الكتابة (أ/ا، ة/ه) بتتفهم لوحدها.",
  'ar.openHours': "مواعيد العمل",
  'ar.openHoursHelp': "بتوقيت الشركة. المواعيد اللي بتعدّي نص الليل شغالة (مثلاً 12:00 ← 02:00).",
  'ar.message': "الرد",
  'ar.messageHelp': "{{name}} بيتحط مكانها الاسم الأول للعميل.",
  'ar.fillIn': "كمّل الأجزاء اللي بين الأقواس قبل ما تشغّله: {parts}",
  'ar.media': "مرفق (اختياري)",
  'ar.mediaUpload': "ارفع صورة / PDF",
  'ar.mediaReplace': "تغيير",
  'ar.mediaRemove': "شيل",
  'ar.mediaHelp': "للمنيو: ارفع صورته أو الـ PDF، ونص الرد هيتبعت معاه.",
  'ar.numbers': "الأرقام",
  'ar.numbersHelp': "سيبهم كلهم من غير علامة عشان يشتغل على كل الأرقام.",
  'ar.notReceiving': "\"استقبال الرسائل\" مقفول",
  'ar.cooldown': "يتكرر لنفس العميل",
  'ar.priority': "الأولوية",
  'ar.priorityHelp': "الأقل بيشتغل الأول، ورد واحد بس لكل رسالة.",
  'ar.cooldown.0': "كل مرة",
  'ar.cooldown.1': "مرة كل ساعة",
  'ar.cooldown.6': "مرة كل 6 ساعات",
  'ar.cooldown.12': "مرة كل 12 ساعة",
  'ar.cooldown.24': "مرة في اليوم",
  'ar.cooldown.72': "مرة كل 3 أيام",
  'ar.cooldown.168': "مرة في الأسبوع",
  'ar.cooldown.720': "مرة في الشهر",
  'ar.enabled': "شغّال",
  'ar.on': "شغّال",
  'ar.off': "مقفول",
  'ar.turnOn': "شغّل",
  'ar.turnOff': "اقفل",
  'ar.turnedOn': "اشتغل",
  'ar.turnedOff': "اتقفل",
  'ar.edit': "تعديل",
  'ar.delete': "حذف",
  'ar.saved': "اتحفظ",
  'ar.confirmDelete': "تحذف الرد التلقائي \"{title}\"؟",
  'ar.allNumbers': "كل الأرقام",
  'ar.sentCount': "اتبعت {n} مرة",
  'ar.delay': "يستنى قبل ما يرد",
  'ar.delayNone': "يرد على طول",
  'ar.delayMinutes': "{n} دقيقة",
  'ar.delayHelp': "لو حد من الفريق رد على العميل في وقت الانتظار، الرد التلقائي بيتلغي.",
  'ar.afterMinutes': "بعد {n} دقيقة لو محدش رد",
  'ar.catchUpTitle': "الرد على اللي اتسابوا من غير رد",
  'ar.catchUpHelp': "مثلاً بعد عطل: العملاء اللي آخر رسالة في محادثتهم منهم من الوقت ده، هيوصلهم الرد التلقائي المناسب، واحد واحد بفاصل من 20 لـ 60 ثانية.",
  'ar.catchUpSince': "من:",
  'ar.catchUpCount': "عدّهم",
  'ar.catchUpStart': "رد على {n} عميل",
  'ar.catchUpConfirm': "تبعت الرد التلقائي لـ {n} عميل دلوقتي؟",
  'ar.catchUpPreview': "{unanswered} اتسابوا من غير رد: {matched} ليهم رد تلقائي مناسب، و{noRule} مالهمش رد وهيتخطّوا.",
  'ar.catchUpStatus.RUNNING': "بيرد دلوقتي…",
  'ar.catchUpStatus.DONE': "آخر تشغيل خلص",
  'ar.catchUpStatus.STOPPED': "آخر تشغيل اتوقف",
  'ar.catchUpStatus.FAILED': "وقف لوحده بعد فشل الإرسال كذا مرة",
  'ar.catchUpCounts': "{sent} اترد عليهم · {skipped} اتخطّوا · {failed} فشلوا",
  'ar.lastError': "آخر إرسال فشل ({when})",
  'ar.silentNumbers': "الردود التلقائية بتشتغل بس على الأرقام اللي مفعّل فيها \"استقبال الرسائل\". مقفول دلوقتي على: {numbers} (فعّله من صفحة الاتصالات).",
  'ar.rulesNote': "رد واحد بس على كل رسالة جاية. البوت بيسكت لو حد من الفريق رد في آخر 10 دقايق، ومع اللي لغوا الاشتراك، ومع العملاء اللي جوه حملة تفاعلية.",
  'ca.title': "تحليل المحادثات بالذكاء الاصطناعي",
  'ca.subtitle': "الذكاء الاصطناعي بيقرا كل محادثات العملاء في فترة ويكتبلك تقرير",
  'ca.new': "تحليل جديد",
  'ca.empty': "مافيش تحليل لسه. اختار فترة والذكاء الاصطناعي هيقرا كل المحادثات اللي فيها.",
  'ca.newTitle': "تحليل محادثات فترة",
  'ca.name': "الاسم",
  'ca.namePlaceholder': "مثلاً: الأسبوع اللي فات",
  'ca.period': "الفترة",
  'ca.lastDays': "آخر {n} يوم",
  'ca.numbers': "الأرقام",
  'ca.numbersHelp': "سيبهم كلهم من غير علامة عشان يتحلل كل الأرقام.",
  'ca.costNote': "الذكاء الاصطناعي بيقرا كل محادثة مرة واحدة (طلب لكل محادثة) وطلب كمان للتقرير، والتكلفة على مفتاح الذكاء الاصطناعي بتاعك. Claude Haiku الأرخص، وOpus الأدق.",
  'ca.count': "عدّ المحادثات",
  'ca.willAnalyse': "هيتحلل {n} محادثة",
  'ca.start': "ابدأ التحليل",
  'ca.started': "التحليل بدأ",
  'ca.chats': "{n} محادثة",
  'ca.back': "→ كل التحليلات",
  'ca.status.RUNNING': "الذكاء الاصطناعي بيقرا",
  'ca.status.SUMMARIZING': "بيكتب التقرير",
  'ca.status.DONE': "خلص",
  'ca.status.FAILED': "فشل",
  'ca.status.CANCELLED': "اتوقف",
  'ca.itemStatus.PENDING': "في الانتظار",
  'ca.itemStatus.WORKING': "بيتقري",
  'ca.itemStatus.FAILED': "فشل",
  'ca.itemStatus.DONE': "خلص",
  'ca.progress': "اتقرى {done} من {total} محادثة · {failed} فشلوا",
  'ca.stop': "إيقاف",
  'ca.stopped': "اتوقف",
  'ca.retryFailed': "أعد المحاولة لـ {n} محادثة فشلت",
  'ca.rewriteReport': "اكتب التقرير تاني",
  'ca.delete': "حذف",
  'ca.deleted': "اتحذف",
  'ca.confirmDelete': "تحذف التحليل ده؟",
  'ca.report': "تقرير الذكاء الاصطناعي",
  'ca.kpi.chats': "محادثات",
  'ca.kpi.orders': "أوردرات",
  'ca.kpi.revenue': "قيمة الأوردرات",
  'ca.kpi.avg': "المتوسط {n} درهم ({k} أوردر معروف سعره)",
  'ca.kpi.reply': "متوسط أول رد",
  'ca.kpi.slow': "{n} ردود اتأخرت أكتر من 30 دقيقة",
  'ca.kpi.unanswered': "محدش رد عليهم",
  'ca.kpi.new': "عملاء جداد",
  'ca.kpi.returning': "عملاء راجعين",
  'ca.kpi.chatsToOrders': "محادثات ← أوردرات",
  'ca.kpi.ads': "محادثات من إعلانات/بوستات",
  'ca.min': "{n} دقيقة",
  'ca.hours': "{n} ساعة",
  'ca.byNumber': "النتايج لكل رقم (فرع)",
  'ca.col.number': "الرقم",
  'ca.intents': "كلّموكم ليه",
  'ca.sources': "قالوا عرفوكم منين",
  'ca.orderTypes': "نوع الأوردر",
  'ca.topItems': "الأكتر طلباً",
  'ca.askedNotOrdered': "سألوا عليه ومطلبوش",
  'ca.areas': "مناطق التوصيل",
  'ca.complaints': "الشكاوى",
  'ca.lostReasons': "ليه مطلبوش",
  'ca.peak': "العملاء بيكلّموكم إمتى (الساعة واليوم)",
  'ca.intent.ORDER': "أوردر",
  'ca.intent.PRICE_INQUIRY': "سؤال عن سعر",
  'ca.intent.MENU_REQUEST': "طلب المنيو",
  'ca.intent.DELIVERY_QUESTION': "سؤال عن التوصيل",
  'ca.intent.RESERVATION': "حجز",
  'ca.intent.COMPLAINT': "شكوى",
  'ca.intent.FEEDBACK': "رأي",
  'ca.intent.OTHER': "حاجة تانية",
  'ca.orderType.DELIVERY': "توصيل",
  'ca.orderType.PICKUP': "استلام",
  'ca.orderType.DINE_IN': "في المطعم",
  'ca.orderType.UNKNOWN': "مش واضح",
  'ca.source.INSTAGRAM': "إنستجرام",
  'ca.source.FACEBOOK': "فيسبوك",
  'ca.source.TIKTOK': "تيك توك",
  'ca.source.SNAPCHAT': "سناب شات",
  'ca.source.GOOGLE': "جوجل",
  'ca.source.DELIVERY_APP': "تطبيق توصيل (طلبات…)",
  'ca.source.FRIEND': "حد رشّحه",
  'ca.source.RETURNING': "عميل قديم",
  'ca.source.PASSING_BY': "عدّى على المطعم",
  'ca.source.NONE': "ماقالش",
  'ca.source.OTHER': "حاجة تانية",
  'ca.filter.ALL': "الكل",
  'ca.filter.ORDERED': "طلبوا",
  'ca.filter.NOT_ORDERED': "مطلبوش",
  'ca.filter.COMPLAINT': "شكاوى",
  'ca.filter.UNANSWERED': "محدش رد",
  'ca.returning': "عميل راجع",
  'ca.orderedTag': "طلب",
  'ca.replyIn': "أول رد: {t}",
  'ci.title': "تحليل العملاء",
  'ci.subtitle': "مين عملاءك وجم منين، من محادثات الواتساب",
  'ci.refresh': "تحديث",
  'ci.export': "تصدير (Excel)",
  'ci.empty': "مافيش محادثات لسه. فعّل \"استقبال الرسائل\" على أرقامك، أو استورد المحادثات من صندوق الوارد.",
  'ci.dataNote': "{total} عميل، من المحادثات اللي عند المنصة من {since}. المحادثات الأقدم مابتتحسبش غير لو اتستوردت من صندوق الوارد.",
  'ci.segmentsTitle': "كل عميل فين دلوقتي",
  'ci.segment.LOYAL': "دائم",
  'ci.segment.ACTIVE': "نشط",
  'ci.segment.NEW': "جديد",
  'ci.segment.AT_RISK': "بدأ يضيع",
  'ci.segment.ONE_TIME': "مرة واحدة",
  'ci.segment.DORMANT': "نايم",
  'ci.segmentRule.LOYAL': "كلّمنا في {loyalActiveDays} أيام مختلفة أو أكتر خلال {loyalWindowDays} يوم، وآخر مرة من أقل من {loyalRecentDays} يوم",
  'ci.segmentRule.ACTIVE': "كلّمنا في آخر {activeDays} يوم",
  'ci.segmentRule.NEW': "أول رسالة منه من أقل من {newDays} يوم",
  'ci.segmentRule.AT_RISK': "جه {atRiskMinDays} أيام أو أكتر قبل كده، وبقاله من {activeDays} لـ {atRiskMaxSilence} يوم ساكت",
  'ci.segmentRule.ONE_TIME': "كلّمنا في يوم واحد بس، من فترة",
  'ci.segmentRule.DORMANT': "جه كذا مرة، وبقاله فترة طويلة ساكت",
  'ci.originsTitle': "جم منين",
  'ci.originsHelp': "دوس على أي سطر عشان تشوف العملاء دول.",
  'ci.origin.AD': "إعلان ممول",
  'ci.origin.POST': "بوست فيسبوك/إنستجرام",
  'ci.origin.LINK': "رابط واتساب (wa.me)",
  'ci.origin.CAMPAIGN': "حملة مننا",
  'ci.origin.OUTREACH': "إحنا اللي بدأنا",
  'ci.origin.DIRECT': "كلّمنا من نفسه",
  'ci.originHelp.AD': "داس على إعلان \"راسلنا على واتساب\"",
  'ci.originHelp.POST': "جه من بوست",
  'ci.originHelp.LINK': "فتح رابط wa.me أو QR",
  'ci.originHelp.CAMPAIGN': "أول رسالة في المحادثة كانت حملة أو متابعة مننا",
  'ci.originHelp.OUTREACH': "إحنا اللي فتحنا المحادثة بإيدينا",
  'ci.originHelp.DIRECT': "هو اللي بدأ، وواتساب ماقالش إنه جه من إعلان أو رابط",
  'ci.originShort.AD': "إعلان",
  'ci.originShort.POST': "بوست",
  'ci.originShort.LINK': "رابط",
  'ci.originShort.CAMPAIGN': "حملة",
  'ci.originShort.OUTREACH': "إحنا",
  'ci.originShort.DIRECT': "من نفسه",
  'ci.matrixTitle': "كل مجموعة جاية منين",
  'ci.matrixHelp': "دوس على أي رقم عشان تشوف العملاء دول.",
  'ci.adsTitle': "الإعلانات والبوستات اللي جابت عملاء",
  'ci.adsEmpty': "لسه مافيش عميل جه من إعلان أو بوست متعلّم.",
  'ci.adsNote': "واتساب بيعلّم أول رسالة جاية من إعلان \"راسلنا على واتساب\". المحادثات اللي قبل التحديث ده مش متعلّمة، إلا لو اتستوردت تاني من صندوق الوارد.",
  'ci.ad': "الإعلان / البوست",
  'ci.adCustomers': "عملاء",
  'ci.adActive': "لسه نشطين",
  'ci.adLoyal': "بقوا دائمين",
  'ci.adUntitled': "إعلان من غير عنوان",
  'ci.adOpen': "فتح",
  'ci.search': "دوّر بالاسم أو الرقم أو الإعلان",
  'ci.showing': "{n} عميل",
  'ci.col.customer': "العميل",
  'ci.col.segment': "المجموعة",
  'ci.col.origin': "جه منين",
  'ci.col.first': "أول رسالة",
  'ci.col.last': "آخر رسالة منه",
  'ci.col.days': "أيام (90 يوم)",
  'ci.col.messages': "رسايل",
  'ci.daysTitle': "عدد الأيام المختلفة اللي كلّمنا فيها (وبين القوسين آخر 90 يوم)",
  'ci.daysNote': "\"أيام\" يعني عدد الأيام المختلفة اللي العميل كلّمك فيها. في المطعم دي أقرب حاجة لعدد المرات اللي طلب فيها.",
  'ci.prev': "السابق",
  'ci.next': "التالي",
  'fu.title': "المتابعة الذكية",
  'fu.subtitle': "ابعت رسالة متابعة واحدة يكتبها الذكاء الاصطناعي لكل عميل راسلك",
  'fu.new': "متابعة جديدة",
  'fu.empty': "مافيش متابعات لسه. اعمل واحدة عشان توصل للعملاء اللي راسلوك في فترة معينة.",
  'fu.open': "فتح",
  'fu.delete': "حذف",
  'fu.back': "→ كل المتابعات",
  'fu.summary': "{total} عميل · {sent} خلصوا · {replied} ردّوا",
  'fu.newTitle': "متابعة ذكية جديدة",
  'fu.editTitle': "إعدادات المتابعة",
  'fu.name': "الاسم",
  'fu.namePlaceholder': "مثلاً: عرض الويك إند لعملاء الأسبوع اللي فات",
  'fu.mode': "الذكاء الاصطناعي يكتب إزاي",
  'fu.mode.PERSONALIZED': "رسالة مخصوصة لكل عميل",
  'fu.mode.PERSONALIZED.help': "الذكاء الاصطناعي بيقرا محادثة كل عميل ويكتبله رسالة واحدة على قد اللي سأل عليه.",
  'fu.mode.SHARED': "رسالة واحدة للكل",
  'fu.mode.SHARED.help': "الذكاء الاصطناعي بيكتب رسالة تسويقية واحدة، ونفس الرسالة بتتبعت لكل العملاء باسم كل واحد.",
  'fu.period': "مين نتابع معاه",
  'fu.lastDays': "آخر {n} يوم",
  'fu.periodMode.DAYS_AGO': "من كام يوم",
  'fu.periodMode.DATE': "في تاريخ",
  'fu.periodMode.RANGE': "فترة",
  'fu.daysAgoOption': "{n} يوم",
  'fu.days': "يوم",
  'fu.periodExplainDay': "هيتجاب العملاء اللي آخر رسالة منهم كانت يوم {day}، ومابعتوش حاجة من ساعتها.",
  'fu.periodExplainRange': "هيتجاب العملاء اللي آخر رسالة منهم كانت بين {from} و{to}.",
  'fu.errPeriod': "اختار اليوم أو الفترة",
  'fu.periodHelp': "بيتجابوا من صندوق الوارد، فلازم الأرقام يكون مفعّل فيها \"استقبال الرسائل\".",
  'fu.lastWord': "بس المحادثات اللي آخر رسالة فيها كانت من العميل",
  'fu.lastWordHelp': "اللي رديناله بعد آخر رسالة منه (بإيدينا أو بحملة أو بفلو) مش هيدخل.",
  'fu.lastWordShown': "بس المحادثات اللي آخر رسالة فيها من العميل (ماردناش عليه بعدها)",
  'fu.periodMode.DATES': "أكتر من تاريخ",
  'fu.daysPickHelp': "اختار تاريخ عشان يتضاف، وكرّر عشان تضيف تواريخ تانية.",
  'fu.daysNone': "ضيف تاريخ واحد على الأقل.",
  'fu.periodExplainDays': "هيتجاب العملاء اللي آخر رسالة منهم كانت في يوم من دول: {days}، ومابعتوش حاجة من ساعتها.",
  'fu.periodShownDays': "العملاء اللي آخر رسالة منهم كانت في يوم من دول: {days}، ومابعتوش حاجة من ساعتها",
  'fu.periodShownDay': "العملاء اللي آخر رسالة منهم كانت يوم {day}، ومابعتوش حاجة من ساعتها",
  'fu.periodShownRange': "العملاء اللي آخر رسالة منهم كانت بين {from} و{to}",
  'fu.lastMessageAt': "آخر رسالة: {when} ({ago})",
  'fu.brief': "تعليمات للذكاء الاصطناعي",
  'fu.briefPlaceholder': "بتبيع إيه، العرض الحالي، الأسعار، مناطق التوصيل، الأسلوب اللي عايزه…",
  'fu.briefHelp': "الذكاء الاصطناعي بيستخدم المعلومات اللي هنا بس، ومش هيألّف أسعار أو خصومات. وكل رسالة بتبدأ بتحية باسم العميل.",
  'fu.greeting': "التحية (أول رسالة)",
  'fu.greetingHelp': "{{name}} بيتحط مكانها الاسم الأول للعميل. سيبها فاضية لو مش عايز تحية.",
  'fu.messageCount': "عدد الرسايل التسويقية لكل عميل",
  'fu.maxDelay': "أطول انتظار بين كل عميل والتاني",
  'fu.minutes': "{n} دقيقة",
  'fu.maxDelayHelp': "كل عميل بتوصله رسالة واحدة، والفاصل قبل العميل اللي بعده عشوائي من 30 ثانية لحد المدة دي.",
  'fu.aiProvider': "مزود الذكاء الاصطناعي",
  'fu.aiModel': "الموديل",
  'fu.sendFrom': "يبعت من",
  'fu.sendFromAuto': "تلقائي: نفس الرقم اللي العميل كلّمه",
  'fu.sendFromHelp': "كل الرسايل هتطلع من الرقم ده.",
  'fu.sendFromMetaHelp': "قاعدة ميتا: الرقم ده يقدر يبعت بس للعملاء اللي كلّموه هو في آخر 24 ساعة. الباقيين يتبعتلهم من الرقم اللي تحت، أو يتخطّوا.",
  'fu.fromNumber': "من {number}",
  'fu.fallback': "رقم للعملاء اللي عدّى عليهم 24 ساعة على رقم ميتا",
  'fu.fallbackNone': "مافيش: اتخطّى العملاء دول",
  'fu.fallbackHelp': "ميتا مش بتسمح برسايل عادية غير خلال 24 ساعة من آخر رسالة من العميل. الأقدم من كده هيتبعتلهم من الرقم ده.",
  'fu.working': "جاري التنفيذ…",
  'fu.createAndFind': "إنشاء وجلب العملاء",
  'fu.saved': "اتحفظ",
  'fu.created': "المتابعة اتعملت",
  'fu.listRebuilt': "قايمة العملاء اتعملت من جديد",
  'fu.messagesReset': "الإعدادات اتغيرت: اكتب الرسايل تاني",
  'fu.confirmDelete': "تحذف المتابعة \"{title}\"؟",
  'fu.deleted': "اتحذفت",
  'fu.hoursAgo': "من {n} ساعة",
  'fu.daysAgo': "من {n} يوم",
  'fu.status.DRAFT': "مسودة",
  'fu.status.GENERATING': "الذكاء الاصطناعي بيكتب",
  'fu.status.READY': "جاهزة للمراجعة",
  'fu.status.SENDING': "جاري الإرسال",
  'fu.status.PAUSED': "متوقفة مؤقتاً",
  'fu.status.DONE': "خلصت",
  'fu.status.CANCELLED': "اتوقفت",
  'fu.item.PENDING': "لسه ماتكتبتش",
  'fu.item.GENERATING': "بتتكتب",
  'fu.item.READY': "جاهزة",
  'fu.item.QUEUED': "في الانتظار",
  'fu.item.SENDING': "جاري الإرسال",
  'fu.item.SENT': "اتبعتت",
  'fu.item.REPLIED': "ردّ",
  'fu.item.SKIPPED': "اتخطّى",
  'fu.item.FAILED': "فشلت",
  'fu.upTo': "فواصل لحد {n} دقيقة",
  'fu.counts': "{total} عميل · {included} داخلين · {skipped} اتخطّوا",
  'fu.progress': "{sent} اتبعتلهم · {replied} ردّوا · {failed} فشلوا · {left} فاضلين",
  'fu.writing': "اتكتب {done} من {total}",
  'fu.editSettings': "الإعدادات",
  'fu.refreshList': "تحديث القايمة",
  'fu.writingStarted': "الذكاء الاصطناعي بيكتب الرسايل",
  'fu.rewriteAll': "إعادة كتابة الكل",
  'fu.write': "اكتب بالذكاء الاصطناعي",
  'fu.confirmStart': "تبدأ الإرسال لـ {n} عميل؟",
  'fu.started': "الإرسال بدأ",
  'fu.start': "ابدأ الإرسال",
  'fu.pause': "إيقاف مؤقت",
  'fu.paused': "اتوقفت مؤقتاً",
  'fu.resume': "استكمال",
  'fu.resumed': "الإرسال كمّل",
  'fu.confirmStop': "توقف الإرسال؟ العملاء اللي ماوصلهمش كل الرسايل مش هيوصلهم الباقي.",
  'fu.stopped': "اتوقفت",
  'fu.stop': "إيقاف",
  'fu.sharedTitle': "الرسالة للكل",
  'fu.ready.hours': "رسالة جاهزة: شغالين 2 الضهر – 4 الفجر",
  'fu.writeMyself': "هكتبها بنفسي",
  'fu.sharedEmpty': "اختار رسالة جاهزة، أو اكتب بنفسك، أو دوس \"اكتب بالذكاء الاصطناعي\"، وبعدين احفظ.",
  'fu.saveMessages': "حفظ الرسالة",
  'fu.noCustomers': "مافيش عميل آخر رسالة منه في الفترة دي.",
  'fu.include': "ضمّه",
  'fu.chatOn': "المحادثة على {number}",
  'fu.sendsFrom': "هيتبعت من {number}",
  'fu.byNumber': "المحادثات اللي اتلقت على كل رقم:",
  'fu.leaveOut': "شيله",
  'fu.confirmLeaveOut': "تشيل العميل ده؟ مش هتوصله الرسالة.",
  'fu.editWhileSending': "احفظ قبل ما ييجي دوره، أو وقّف الإرسال مؤقتاً الأول.",
  'fu.writingOne': "الذكاء الاصطناعي بيكتب…",
  'fu.rewriteOne': "إعادة كتابة",
  'nav.campaigns': 'الحملات',
  'nav.interactiveCampaign': 'الحملات التفاعلية',
  'nav.users': 'المستخدمون',
  'nav.settings': 'الإعدادات',
  'nav.superAdmin': 'إدارة المنصة',

  // الصفحة التعريفية
  'landing.badge': 'منصّة تسويق واتساب للشركات',
  'landing.title': 'منصّة واحدة لإدارة',
  'landing.subtitle': 'حملات موجّهة، وصندوق وارد موحّد، وتقارير دقيقة لكل حملة — بدل أدوات متفرّقة وملفات إكسل.',
  'landing.ctaTrial': 'ابدأ مجاناً — {days} يوم',
  'landing.menu.features': 'المميزات',
  'landing.menu.how': 'طريقة العمل',
  'landing.menu.plans': 'الباقات',

  'landing.features.title': 'كل ما تحتاجه لتشغيل تسويقك بشكل صحيح',
  'landing.features.campaigns.title': 'حملات لفئات عملائك',
  'landing.features.campaigns.text': 'اختر فئة وأرسل لها رسالة واحدة بنص أو صورة أو ملف، بإيقاع منظّم يحافظ على جودة التوصيل.',
  'landing.features.inbox.title': 'صندوق وارد موحّد',
  'landing.features.inbox.text': 'اقرأ المحادثة كاملة، ورُد بنص أو ملفات، وتعرف من ما زال ينتظر رداً — فريقك كله في مكان واحد.',
  'landing.features.analytics.title': 'تقارير توضّح ما الذي نجح',
  'landing.features.analytics.text': 'نسب التسليم والقراءة والرد لكل حملة، وسرعة رد فريقك، وقائمة بكل من تفاعل معك.',
  'landing.features.contacts.title': 'قائمة تتحدّث تلقائياً',
  'landing.features.contacts.text': 'استورد من إكسل أو CSV، ورتّب بالفئات، وصدّر متى شئت. وأي رقم جديد يراسلك يُضاف تلقائياً.',
  'landing.features.optout.title': 'احترام رغبة العميل',
  'landing.features.optout.text': 'من يرد بكلمة «إلغاء» أو STOP يتوقف الإرسال إليه فوراً، وتصله رسالة تأكيد، ويُستثنى من الحملات القادمة.',
  'landing.features.privacy.title': 'بيانات كل شركة منفصلة',
  'landing.features.privacy.text': 'جهات الاتصال والحملات والمحادثات معزولة تماماً — لا يراها سوى فريقك.',

  'landing.steps.title': 'من التسجيل إلى أول حملة في اليوم نفسه',
  'landing.steps.one.title': 'أنشئ حسابك',
  'landing.steps.one.text': 'أدخل رقم الواتساب وأكّد الرمز الذي يصلك. بدون بطاقة ائتمان.',
  'landing.steps.two.title': 'اربط رقمك',
  'landing.steps.two.text': 'امسح رمز QR مرة واحدة، بنفس طريقة واتساب ويب.',
  'landing.steps.three.title': 'استورد وأرسل',
  'landing.steps.three.text': 'ارفع جهات اتصالك، اكتب الرسالة، وتابع الردود وهي تصل.',

  'landing.plans.title': 'باقات تكبر مع شركتك',
  'landing.plans.subtitle': 'ابدأ بتجربة مجانية {days} يوم، واشترك متى كنت جاهزاً. تقدر تغيّر باقتك في أي وقت.',
  'landing.plans.popular': 'الأكثر طلباً',
  'landing.plans.messages': '{count} رسالة شهرياً',
  'landing.plans.contacts': '{count} جهة اتصال',
  'landing.plans.numbers': '{count} رقم واتساب',
  'landing.plans.users': '{count} مستخدم من فريقك',
  'landing.plans.included': 'صندوق الوارد والتقارير مشمولة',
  'landing.plans.startFree': 'ابدأ مجاناً',
  'landing.titleAccent': 'تسويقك على واتساب',
  'landing.ctaDemo': 'شاهد طريقة العمل',
  'landing.note1': 'بدون بطاقة ائتمان',
  'landing.note2': 'تربط رقمك بمسح رمز QR خلال دقيقة',
  'landing.note3': 'بدون تثبيت أي برنامج',
  'landing.menu.faq': 'الأسئلة الشائعة',
  'landing.mock.campaign': 'حملة عروض أكتوبر',
  'landing.mock.running': 'تعمل الآن',
  'landing.mock.sent': 'أُرسلت',
  'landing.mock.delivered': 'وصلت',
  'landing.mock.read': 'قُرئت',
  'landing.mock.replied': 'ردّوا',
  'landing.mock.inbox': 'صندوق الوارد',
  'landing.mock.msgIn': 'كم السعر؟',
  'landing.mock.msgOut': 'أكيد، أرسل لك التفاصيل الآن 👌',
  'landing.pillars.send.title': 'أرسل',
  'landing.pillars.send.text': 'حملة واحدة تصل إلى فئة كاملة من عملائك، بنص أو صورة أو ملف.',
  'landing.pillars.reply.title': 'استقبل',
  'landing.pillars.reply.text': 'كل الردود تصل إلى صندوق واحد، وفريقك يرد من المنصّة مباشرة.',
  'landing.pillars.measure.title': 'قِس',
  'landing.pillars.measure.text': 'تعرف من استلم ومن قرأ ومن ردّ، وسبب أي رسالة لم تصل.',
  'landing.features.subtitle': 'ليست أداة إرسال فقط — دورة كاملة من الرسالة حتى الرد والقرار.',
  'landing.steps.subtitle': 'ثلاث خطوات فقط، بدون إعدادات معقّدة ولا انتظار موافقات.',
  'landing.policy.title': 'إرسال منظّم، وسمعة محفوظة',
  'landing.policy.text': 'المنصّة تتحكّم في إيقاع الإرسال بدل إرسال الرسائل دفعة واحدة — توصيل أعلى، وتجربة أفضل لمن يستقبلها.',
  'landing.policy.chip1': 'فاصل زمني بين كل رسالة',
  'landing.policy.chip2': 'حد يومي لكل رقم',
  'landing.policy.chip3': 'نافذة إرسال بتوقيت بلدك',
  'landing.policy.chip4': 'إيقاف تلقائي عند ارتفاع الفشل',
  'landing.plans.note': 'كل الباقات تشمل الواجهة بالعربية والإنجليزية، وإلغاء اشتراك تلقائي، ودعم عبر واتساب.',
  'landing.faq.title': 'الأسئلة الشائعة',
  'landing.faq.q1': 'هل أحتاج إلى تثبيت برنامج؟',
  'landing.faq.a1': 'لا. المنصّة تعمل من المتصفح، وتربط رقمك بمسح رمز QR مرة واحدة — تماماً مثل واتساب ويب.',
  'landing.faq.q2': 'هل أقدر أستخدم رقمي الحالي؟',
  'landing.faq.a2': 'نعم، نفس الرقم الذي يعرفه عملاؤك. والردود تصل إلى جوالك وإلى المنصّة في الوقت نفسه.',
  'landing.faq.q3': 'كيف تحافظون على جودة الإرسال؟',
  'landing.faq.a3': 'الرسائل تخرج بإيقاع منظّم لا دفعة واحدة: فاصل زمني، وحد يومي، ونافذة وقت، مع إيقاف تلقائي إذا ارتفعت نسبة الفشل. ومن يطلب إيقاف الرسائل يُستثنى فوراً.',
  'landing.faq.q4': 'أين تصل الردود؟',
  'landing.faq.a4': 'في صندوق وارد موحّد داخل المنصّة: المحادثة كاملة، ومن ما زال ينتظر رداً، وتقدر ترد بنص أو ملفات دون مغادرة الشاشة.',
  'landing.faq.q5': 'هل أعرف نتيجة الحملة؟',
  'landing.faq.a5': 'نعم. لكل حملة تقرير بنسب التسليم والقراءة والرد، وأسباب الرسائل التي لم تصل، وقائمة بكل من تفاعل — ويمكن تنزيله كملف إكسل.',
  'landing.faq.q6': 'هل أقدر ألغي في أي وقت؟',
  'landing.faq.a6': 'نعم. التجربة مجانية بالكامل وبدون بطاقة ائتمان، وتقدر توقف اشتراكك أو تغيّر باقتك متى شئت.',
  'landing.cta.title': 'جرّبها على حملة واحدة، وقارن النتيجة',
  'landing.cta.text': 'دقائق للإعداد، وأول حملة تقدر ترسلها اليوم. بدون التزام.',
  'landing.footer.tagline': 'منصّة تسويق واتساب للشركات — إرسال، وردود، وتقارير في مكان واحد.',


  // تسجيل الدخول
  'login.welcome': "أهلاً بك!",
  'login.subtitle': "سجّل الدخول للوصول إلى حسابك",
  'login.identifier': 'الإيميل أو رقم الواتساب',
  'login.identifierPlaceholder': 'you@email.com أو ‎+971...',
  'login.password': 'كلمة المرور',
  'login.submit': 'دخول',
  'login.submitting': 'جارٍ الدخول...',
  'login.newHere': 'أول مرة هنا؟',
  'login.invalidIdentifier': 'اكتب الإيميل أو رقم الواتساب',
  'login.passwordMin': 'كلمة المرور لازم تكون 6 أحرف على الأقل',

  // إنشاء حساب
  'signup.title': "أنشئ حسابك",
  'signup.trialSubtitle': 'ابدأ بتجربة مجانية {days} يوم',
  'signup.closed': 'التسجيل مغلق حاليًا',
  'signup.closedText': "التسجيل مغلق حالياً. تواصل معنا لفتح حساب لك.",
  'signup.goSignIn': "اذهب إلى تسجيل الدخول",
  'signup.phone': 'رقم الواتساب',
  'signup.phoneHelp': "اختر الدولة واكتب رقمك. سيصلك رمز تحقق على واتساب.",
  'signup.sendCode': "أرسل الرمز",
  'signup.sending': 'جارٍ الإرسال…',
  'signup.codeSent': "أرسلنا الرمز على واتساب",
  'signup.change': 'تغيير',
  'signup.code': "رمز التحقق",
  'signup.resendIn': 'إعادة الإرسال بعد {seconds} ثانية',
  'signup.resend': "إرسال رمز جديد",
  'signup.name': 'اسمك',
  'signup.company': 'اسم الشركة',
  'signup.password': 'كلمة المرور',
  'signup.passwordPlaceholder': '8 أحرف على الأقل',
  'signup.passwordHelp': "ستدخل برقم الواتساب وكلمة المرور هذه.",
  'signup.create': 'إنشاء الحساب',
  'signup.creating': 'جارٍ الإنشاء…',
  'signup.created': "تم إنشاء الحساب. أهلاً بك!",
  'signup.haveAccount': "لديك حساب بالفعل؟",
  'signup.errorSend': "تعذّر إرسال الرمز",
  'signup.errorCreate': 'تعذّر إنشاء الحساب',

  // الاتصالات
  'conn.title': "اتصالات الواتساب",
  'conn.loading': "جارٍ تحميل الاتصالات...",
  'conn.refresh': "تحديث",
  'conn.activeSessions': "الاتصالات النشطة",
  'conn.empty': "لا توجد اتصالات واتساب. أنشئ اتصالاً جديداً للبدء.",
  'conn.connectedAs': "متصل باسم:",
  'conn.receiving': "يستقبل الرسائل — الردود تظهر في صندوق الوارد",
  'conn.notReceiving': "لا يستقبل الرسائل: أي رد على هذا الرقم لن يصل",
  'conn.connect': "ربط",
  'conn.viewQr': "عرض رمز QR",
  'conn.restart': "إعادة تشغيل",
  'conn.remove': "حذف",
  'conn.newSession': "اتصال واتساب جديد",
  'conn.newSessionSubtitle': "اكتب اسم يميّز الاتصال ده",
  'conn.provider': "مزوّد الواتساب *",
  'conn.providerHelp': "اختر المزوّد الذي سيربط الواتساب",
  'conn.sessionName': "اسم الاتصال *",
  'conn.sessionNamePlaceholder': "مثال: المبيعات، الدعم، الخدمة",
  'conn.sessionNameHelp': "استخدم اسماً واضحاً يسهل تمييزه",
  'conn.interactive': "حملة تفاعلية",
  'conn.interactiveHelp': "بيفعّل استقبال الرسائل للمحادثات التلقائية",
  'conn.create': "إنشاء الاتصال",
  'conn.creating': "جارٍ الإنشاء...",
  'conn.qrTitle': "امسح رمز QR من الواتساب",
  'conn.qrStep1': "افتح واتساب على تليفونك، وروح على",
  'conn.qrStep2': "الإعدادات ← الأجهزة المرتبطة ← ربط جهاز",
  'conn.qrGenerating': "جارٍ إنشاء رمز QR...",
  'conn.qrWait': "استنى لحظة",
  'conn.qrRefresh': "تحديث الرمز",
  'conn.qrExpired': "انتهت صلاحية رمز QR",
  'conn.close': "إغلاق",
  'conn.statusConnected': "متصل",
  'conn.statusWaitingQr': "في انتظار رمز QR",
  'conn.requesting': "جارٍ الطلب...",
  'conn.stopReceivingTitle': "إيقاف استقبال الرسائل من الرقم ده",
  'conn.receiveTitle': "استقبال الردود من هذا الرقم في صندوق الوارد",
  'conn.saving': "جارٍ الحفظ...",
  'conn.stopReceiving': "إيقاف الاستقبال",
  'conn.receiveMessages': "استقبال الرسائل",
  'conn.errLoad': "تعذّر تحميل اتصالات الواتساب",
  'conn.errName': "اكتب اسم للاتصال",
  'conn.errWaha': "اضبط بيانات WAHA في إعدادات النظام",
  'conn.errEvolution': "اضبط بيانات Evolution API في إعدادات النظام",
  'conn.errQuepasa': "اضبط بيانات Quepasa في إعدادات النظام",
  'conn.metaName': "واتساب Cloud API (ميتا)",
  'conn.metaIntro': "الربط الرسمي من ميتا، من غير QR. انسخ القيم دي من تطبيقك في Meta for Developers ← WhatsApp ← API Setup.",
  'conn.metaPhoneId': "معرّف رقم الهاتف (Phone Number ID)",
  'conn.metaWabaId': "معرّف حساب واتساب للأعمال (WABA ID)",
  'conn.metaToken': "رمز الوصول الدائم (System User)",
  'conn.metaTokenHelp': "أنشئه من إعدادات الأعمال ← مستخدمو النظام، بصلاحيتي whatsapp_business_messaging و whatsapp_business_management.",
  'conn.metaAppSecret': "المفتاح السري للتطبيق (App Secret)",
  'conn.metaAppSecretHelp': "من إعدادات التطبيق ← أساسي. يُستخدم للتأكد إن الرسائل الواردة جاية فعلاً من ميتا.",
  'conn.metaTemplateNote': "الأشخاص اللي ما راسلوكش آخر 24 ساعة ما يستقبلوش غير القوالب المعتمدة. حملات القوالب جاية في الخطوة الجاية.",
  'conn.errMetaFields': "املأ حقول ميتا الأربعة",
  'conn.metaWebhookTitle': "آخر خطوة: اضبط الـ Webhook في ميتا",
  'conn.metaWebhookSteps': "في تطبيقك على Meta for Developers افتح WhatsApp ← Configuration ← Webhook ← Edit، والصق القيمتين دول، وبعدين اشترك في حقل \"messages\".",
  'conn.metaCallbackUrl': "رابط الاستقبال (Callback URL)",
  'conn.metaVerifyToken': "رمز التحقق (Verify token)",
  'conn.metaNoPublicUrl': "المنصة لسه ملهاش عنوان عام (APP_URL). اضبطه وبعدين افتح النافذة دي تاني من زرار Webhook.",
  'conn.metaWebhookButton': "Webhook",
  'conn.metaQuality': "جودة الرقم",
  'conn.metaCheck': "تحقق من الاتصال",
  'conn.metaChecked': "ميتا أكدت الاتصال",
  'conn.copy': "نسخ",
  'conn.copied': "اتنسخ",
  'conn.done': "تم",
  'conn.removed': "تم حذف الاتصال",
  'conn.restarted': "تمت إعادة تشغيل الاتصال",
  'conn.qrRequested': "تم طلب رمز QR. استنى شوية...",
  'conn.qrUnavailable': "رمز QR غير متاح",
  'conn.errQrFetch': "تعذّر جلب رمز QR",
  'conn.errUnknown': "خطأ غير معروف",
  'conn.errQuota': "وصلت إلى الحد الأقصى للاتصالات. قم بترقية باقتك للمتابعة.",
  'conn.errCreate': "تعذّر إنشاء الاتصال",
  'conn.errRemove': "تعذّر حذف الاتصال",
  'conn.errRestart': "تعذّرت إعادة التشغيل",
  'conn.inboxOn': "تم تفعيل استقبال الرسائل",
  'conn.inboxOff': "تم إيقاف استقبال الرسائل",
  'conn.errInbox': "تعذّر تحديث استقبال الرسائل",
  'conn.errQrRequest': "تعذّر طلب رمز QR",
  'conn.statusStopped': "متوقف",
  'conn.statusError': "خطأ",
  'conn.connectedAsName': "متصل باسم: {name}",

  // الرسائل وجهات الاتصال
  'inbox.title': "الرسائل",
  'inbox.subtitle': "الرسائل الواردة على أرقام الواتساب الخاصة بك",
  'inbox.empty': "لا توجد محادثات بعد.",
  'inbox.emptyHint': "فعّل استقبال الرسائل لأي اتصال من صفحة الاتصالات.",
  'inbox.you': "انت:",
  'inbox.loadMore': "عرض المزيد",
  'inbox.selectConversation': "اختر محادثة لقراءتها",
  'inbox.unsubscribed': "ألغى الاشتراك",
  'inbox.readOnly': "للقراءة فقط",
  'inbox.notInContacts': "غير موجود في جهات الاتصال",
  'inbox.noPhone': "من غير رقم",
  'inbox.readOnlyHint': "هذه محادثة قديمة محفوظة بدون رقم، يمكن قراءتها فقط.",
  'inbox.uploading': "جارٍ رفع الملف…",
  'inbox.search': "ابحث بالاسم أو الرقم أو نص الرسالة",
  'inbox.attach': "إرفاق ملف",
  'inbox.quickReplies': "رسايل جاهزة (الردود التلقائية)",
  'inbox.quickSearch': "دوّر في الرسايل الجاهزة…",
  'inbox.quickEmpty': "مافيش رسايل جاهزة لسه. ضيفها من صفحة الردود التلقائية.",
  'inbox.quickRemoveMedia': "شيل",
  'inbox.quickFillIn': "كمّل الأجزاء اللي بين الأقواس قبل الإرسال.",
  'inbox.reply': "اكتب ردك…",
  'inbox.send': "إرسال",
  'inbox.sending': "جارٍ الإرسال…",
  'inbox.filterReplies': "الردود",
  'inbox.filterUnread': "غير المقروء",
  'inbox.filterAll': "الكل",
  'inbox.srcCampaign': "حملة",
  'inbox.srcFlow': "حملة تفاعلية",
  'inbox.srcAuto': "تلقائي",
  'inbox.today': "اليوم",
  'inbox.yesterday': "أمس",
  'inbox.waContact': "جهة اتصال واتساب",
  'inbox.conversationsCount': "{shown} من {total} محادثة",
  'inbox.import': "استيراد المحادثات القديمة",
  'inbox.importing': "جارٍ الاستيراد {done}/{total}…",
  'inbox.importingShort': "جارٍ الاستيراد…",
  'inbox.imported': "{messages} رسالة في {conversations} محادثة",
  'inbox.importTitle': "استيراد سجل المحادثات المحفوظ عند المزوّد إلى صندوق الوارد",
  'inbox.loadMedia': "تحميل {type}",
  'inbox.errConversations': "تعذّر تحميل المحادثات",
  'inbox.errMessages': "تعذّر تحميل الرسائل",
  'inbox.errFile': "تعذّر تحميل الملف",
  'inbox.errImport': "فشل الاستيراد",
  'inbox.errImportStart': "تعذّر بدء الاستيراد",
  'inbox.errSend': "تعذّر إرسال الرسالة",
  'inbox.errUpload': "تعذّر رفع الملف",
  'inbox.errAttachment': "تعذّر إرسال المرفق",
  'contacts.title': "جهات الاتصال",
  'contacts.error': "خطأ",
  'contacts.tryAgain': "حاول تاني",
  'contacts.cancelSelection': "إلغاء التحديد",
  'contacts.categories': "الفئات",
  'contacts.importCsv': "استيراد CSV",
  'contacts.exportExcel': "تصدير إلى إكسل",
  'contacts.exporting': "جارٍ التصدير...",
  'contacts.exported': "تم تصدير جهات الاتصال",
  'contacts.errExport': "تعذّر تصدير جهات الاتصال",
  'contacts.selectAll': "تحديد الكل",
  'contacts.deselectAll': "إلغاء تحديد الكل",
  'contacts.loading': "جارٍ التحميل...",
  'contacts.empty': "لا توجد جهات اتصال.",
  'contacts.colName': "الاسم",
  'contacts.colPhone': "الرقم",
  'contacts.colEmail': "الإيميل",
  'contacts.colCategory': "الفئة",
  'contacts.colUpdated': "آخر تحديث",
  'contacts.colActions': "إجراءات",
  'contacts.sourceWhatsApp': "واتساب",
  'contacts.sourceWhatsAppTitle': "أُضيف تلقائياً عند أول رسالة من هذا الرقم على واتساب",
  'contacts.unsubscribed': "ألغى الاشتراك",
  'contacts.edit': "تعديل",
  'contacts.delete': "حذف",
  'contacts.confirm': "تأكيد؟",
  'media.image': "📷 صورة",
  'media.video': "🎥 فيديو",
  'media.audio': "🎧 رسالة صوتية",
  'media.document': "📄 ملف",
  'media.sticker': "🩵 ملصق",
  'media.location': "📍 موقع",

  // التحليلات والباقات
  'an.title': "تحليل الحملة",
  'an.window': "مدة احتساب الردود",
  'an.days': "{count} يوم",
  'an.day': "يوم واحد",
  'an.sync': "تحديث حالات التسليم",
  'an.syncing': "جارٍ التحديث…",
  'an.syncNow': "حدّث الآن",
  'an.syncTitle': "جلب تأكيدات التسليم والقراءة من واتساب للرسائل المُرسلة",
  'an.syncMissing': "حالة التسليم/القراءة ناقصة لـ{count} رسالة. حدّث مرة واحدة، والرسائل الجديدة بتتحدّث لوحدها.",
  'an.synced': "اتحدّثت حالة {count} رسالة",
  'an.loading': "جارٍ تحميل التحليل…",
  'an.errLoad': "تعذّر تحميل التحليل",
  'an.errSync': "تعذّر تحديث حالات التسليم",
  'an.kpiSent': "أُرسلت",
  'an.kpiPending': "فاضل {count}",
  'an.kpiDelivered': "وصلت",
  'an.kpiDeliveredSub': "{sent} من {total} مبعوتة",
  'an.kpiRead': "قُرئت",
  'an.kpiReadSub': "{count} من التي وصلت (كحد أدنى*)",
  'an.kpiReplied': "ردّوا",
  'an.kpiRepliedSub': "{people} شخص · {human} على الأغلب ردود بشرية",
  'an.kpiUnsub': "ألغوا الاشتراك",
  'an.kpiUnsubSub': "{rate}% من المبعوت",
  'an.kpiFailed': "فشلت",
  'an.kpiFailedSub': "{rate}% من المحاولات",
  'an.funnel': "مسار التفاعل",
  'an.funnelHuman': "ردود بشرية على الأغلب",
  'an.timing': "وقت أول رد",
  'an.median': "الوسيط:",
  'an.under5m': "أقل من 5 دقايق",
  'an.under1h': "من 5 لـ60 دقيقة",
  'an.under24h': "من ساعة لـ24 ساعة",
  'an.over24h': "أكتر من يوم",
  'an.autoNote': "{count} رد وصلوا في أقل من 20 ثانية — غالبًا ردود آلية من WhatsApp Business.",
  'an.failures': "أسباب فشل الرسائل",
  'an.noFailures': "لا يوجد أي فشل 🎉",
  'an.perDay': "الردود كل يوم",
  'an.variations': "نسبة الرد حسب نسخة الرسالة",
  'an.variation': "النسخة",
  'an.rate': "النسبة",
  'an.whoReplied': "مين رد",
  'an.hideAuto': "إخفاء الردود الآلية",
  'an.searchReplies': "ابحث بالاسم أو الرقم أو نص الرد",
  'an.exportCsv': "تصدير CSV",
  'an.noReplies': "لا توجد ردود في هذه المدة.",
  'an.colContact': "جهة الاتصال",
  'an.colAfter': "رد بعد",
  'an.colFirst': "أول رد",
  'an.colReplies': "الردود",
  'an.openChat': "افتح المحادثة →",
  'an.auto': "آلي؟",
  'an.footnote': "* من يُغلق علامات القراءة في واتساب تظهر رسالته «وصلت» فقط، لذلك نسبة القراءة حد أدنى. والرد هو أي رسالة من نفس الرقم بعد رسالة الحملة خلال المدة المختارة. أما المحادثات القديمة المحفوظة بدون رقم فلا يمكن ربطها بجهة اتصال.",
  'plan.title': "الباقة والاشتراك",
  'plan.usedThisMonth': "المستهلك هذا الشهر",
  'plan.messagesOf': "{used} / {limit} رسالة",
  'plan.unlimited': "بلا حدود",
  'plan.plan': "الباقة",
  'plan.status': "الحالة",
  'plan.statusTrial': "تجربة",
  'plan.statusActive': "مفعّلة (مدفوعة)",
  'plan.statusSuspended': "موقوفة (لا يمكن الإرسال)",
  'plan.paidUntil': "مدفوعة حتى",
  'plan.addMonth': "+شهر",
  'plan.paidUntilHelp': "يتوقف الإرسال بعد هذا التاريخ حتى يتم التجديد.",
  'plan.updated': "تم تحديث الباقة",
  'plan.errUpdate': "تعذّر تحديث الباقة",
  'plan.perMonth': "{count} رسالة شهريًا",
  'plan.unlimitedMessages': "رسائل بلا حدود",
  'plan.summary': "{contacts} جهة اتصال · {connections} اتصال · {users} مستخدم",
  'plan.saving': "جارٍ الحفظ…",
  'sub.ends': "باقتك {plan} تنتهي خلال {days} يوم.",
  'sub.left': "تبقّت لك {left} رسالة فقط هذا الشهر في باقة {plan}.",
  'sub.usage': "{used} / {limit} رسالة هذا الشهر",
  'sub.planTrial': "تجربة مجانية",
  'sub.planStarter': "ستارتر",
  'sub.planPro': "برو",
  'sub.planBusiness': "بيزنس",
  'sub.planInternal': "داخلي (بلا حدود)",

  // الحملات
  'camp.title': "الحملات",
  'camp.loading': "جارٍ تحميل الحملات...",
  'camp.created': "الحملات المُنشأة",
  'camp.contacts': "جهات الاتصال:",
  'camp.sent': "أُرسلت:",
  'camp.sessions': "الاتصالات:",
  'camp.new': "حملة جديدة",
  'camp.edit': "تعديل الحملة",
  'camp.duplicate': "تكرار الحملة",
  'camp.duplicateTitle': "تكرار حملة",
  'camp.duplicateSub': "منسوخة من \"{name}\". عدّل اللي إنت عايزه وبعدين اعمل الحملة، والحملة الأصلية مش هتتغير.",
  'camp.copySuffix': "(نسخة)",
  'camp.newSubtitle': "جهّز حملة الرسائل على واتساب",
  'camp.editSubtitle': "التعديل يُطبّق على الرسائل التي لم تُرسل بعد",
  'camp.basicInfo': "البيانات الأساسية",
  'camp.basicInfoSub': "حدّد تفاصيل الحملة الأساسية",
  'camp.name': "اسم الحملة *",
  'camp.namePlaceholder': "مثال: عروض الجمعة البيضاء 2024",
  'camp.categories': "فئات جهات الاتصال *",
  'camp.categoriesHelp': "اختر الفئات التي ستستقبل الحملة",
  'camp.categoriesLocked': "المستلمين اتحددوا وقت إنشاء الحملة ومينفعش يتغيّروا",
  'camp.noCategories': "لا توجد فئات متاحة",
  'camp.categoriesSelected': "تم اختيار {count} فئة",
  'camp.connections': "اتصالات الواتساب *",
  'camp.multiSession': "توزيع على أكتر من اتصال",
  'camp.multiSessionHelp': "بيوزّع الإرسال على أكتر من اتصال، ولو واحد وقع الباقي بيكمّل.",
  'camp.noConnections': "لا توجد اتصالات واتساب متاحة",
  'camp.active': "نشط",
  'camp.connectionsSelected': "تم اختيار {count} اتصال",
  'camp.randomDelay': "الفاصل العشوائي (ثواني)",
  'camp.randomDelayHelp': "فاصل عشوائي إضافي بين الرسائل (0-{max} ثانية)، يُضاف إلى الفاصل الأدنى في سياسة الإرسال",
  'camp.whenToSend': "موعد الإرسال",
  'camp.sendNow': "الحملة هتبدأ فور إنشائها",
  'camp.scheduleFor': "جدولة في:",
  'camp.scheduleHelp': "اختار تاريخ ووقت محددين",
  'camp.messages': "رسائل الحملة",
  'camp.messagesSub': "جهّز المحتوى الذي سيُرسل إلى العملاء",
  'camp.variablesHint': "خصّص رسائلك باستخدام:",
  'camp.addMessages': "ضيف رسالة أو أكتر تتبعت بالترتيب",
  'camp.message': "رسالة",
  'camp.remove': "حذف",
  'camp.useVariations': "استخدم نسخ مختلفة من النص",
  'camp.variations': "نسخ النص",
  'camp.newVariation': "نسخة جديدة",
  'camp.removeVariation': "حذف النسخة",
  'camp.availableVars': "المتغيرات المتاحة:",
  'camp.variables': "المتغيرات:",
  'camp.file': "ملف",
  'camp.useVariationsShort': "نسخ متعددة",
  'camp.uploading': "جارٍ الرفع",
  'camp.upload': "رفع",
  'camp.uploadingFile': "جارٍ رفع الملف...",
  'camp.clickUpload': "اضغط لرفع ملف",
  'camp.view': "عرض",
  'camp.removeFile': "حذف الملف",
  'camp.fileName': "اسم الملف (اختياري)",
  'camp.caption': "تعليق...",
  'camp.waitTime': "وقت الانتظار",
  'camp.waitHelp': "ينتظر قليلاً قبل إرسال الرسالة التالية",
  'camp.waitMin': "الحد الأدنى: ثانية واحدة",
  'camp.waitMax': "الحد الأقصى: 3600 ثانية (ساعة)",
  'camp.noMessages': "لا توجد رسائل في التسلسل",
  'camp.noMessagesHint': "اضغط «+ رسالة» لبدء حملتك.",
  'camp.create': "إنشاء الحملة",
  'camp.saveChanges': "حفظ التعديلات",
  'camp.model': "الموديل *",
  'camp.suggestedModels': "موديلات مقترحة:",
  'camp.systemPrompt': "توجيه النظام *",
  'camp.systemPromptHelp': "بيحدد سلوك الذكاء الاصطناعي وطريقة رده",
  'camp.userPrompt': "توجيه المستخدم *",
  'camp.openaiModel': "اكتب موديل OpenAI (مثال: gpt-3.5-turbo)",
  'camp.groqModel': "اكتب موديل Groq (مثال: llama-3.1-8b-instant)",
  'camp.report': "تقرير الحملة",
  'camp.reportLoading': "جارٍ تحميل التقرير...",
  'camp.refreshReport': "تحديث التقرير",
  'camp.status': "الحالة:",
  'camp.createdBy': "أنشأها:",
  'camp.createdOn': "تاريخ الإنشاء:",
  'camp.startedOn': "تاريخ البدء:",
  'camp.completedOn': "تاريخ الانتهاء:",
  'camp.stats': "إحصائيات الإرسال",
  'camp.totalContacts': "إجمالي جهات الاتصال",
  'camp.messagesSent': "رسائل أُرسلت",
  'camp.messagesFailed': "رسائل فشلت",
  'camp.messagesPending': "رسائل في الانتظار",
  'camp.messagesSkipped': "رسائل اتخطّت",
  'camp.bySession': "التوزيع حسب الاتصال",
  'camp.session': "الاتصال",
  'camp.total': "الإجمالي",
  'camp.colSent': "أُرسلت",
  'camp.colFailed': "فشلت",
  'camp.colSkipped': "اتخطّت",
  'camp.details': "تفاصيل الرسائل",
  'camp.colName': "الاسم",
  'camp.colPhone': "الرقم",
  'camp.colStatus': "الحالة",
  'camp.colSentAt': "وقت الإرسال",
  'camp.colError': "الخطأ",
  'camp.errorDetails': "تفاصيل الخطأ:",
  'camp.noMessagesFound': "لا توجد رسائل",
  'camp.previous': "السابق",
  'camp.next': "التالي",
  'camp.analyticsTitle': "تحليل الحملة: التسليم والقراءة والردود",
  'camp.reportTitle': "عرض تقرير الحملة",
  'camp.pauseTitle': "إيقاف مؤقت",
  'camp.resumeTitle': "استئناف",
  'camp.editTitle': "تعديل الحملة",
  'camp.deleteTitle': "حذف الحملة",
  'camp.errLoad': "تعذّر تحميل الحملات",
  'camp.errCategory': "اختار فئة واحدة على الأقل",
  'camp.errConnection': "اختار اتصال واتساب واحد على الأقل",
  'camp.errMessage': "ضيف رسالة واحدة على الأقل",
  'camp.claudeHelp': "Claude بيكتب رسالة مخصوصة لكل جهة اتصال من التعليمات اللي بتكتبها. محتاج مفتاح Claude في الإعدادات ← الذكاء الاصطناعي.",
  'camp.templateOption': "قالب واتساب (Cloud API)",
  'camp.templateNeedsMeta': "اختار اتصال واتساب Cloud API الأول: القوالب بتيجي من حساب واتساب للأعمال بتاعه.",
  'camp.templateChoose': "اختار قالب معتمد",
  'camp.templateNone': "مافيش قوالب معتمدة لسه",
  'camp.templatePending': "فيه {n} قالب لسه مش معتمدين (قيد المراجعة أو مرفوضين)",
  'camp.templateMissing': "القالب \"{name}\" مبقاش معتمد على الحساب ده",
  'camp.templateHeaderMedia': "رابط الـ {type} اللي فوق الرسالة",
  'camp.templateParams': "قيم القالب (تقدر تستخدم {{name}} و{{phone}}...)",
  'camp.templateParamPlaceholder': "مثلاً {{name}}",
  'camp.errTemplate': "اختار القالب لكل رسالة من نوع قالب واتساب",
  'camp.errTemplateMedia': "القالب ده فوقه صورة أو فيديو أو ملف: ارفعه قبل الحفظ",
  'camp.templateCoupon': "كود الخصم (زرار نسخ الكود)",
  'camp.templateUrlSuffix': "آخر الرابط لزرار \"{button}\"",
  'camp.errTemplateCoupon': "القالب ده فيه زرار نسخ كود: اكتب كود الخصم",
  'camp.templateUpload': "رفع",
  'camp.templateUploading': "جاري الرفع…",
  'camp.templateUploadFailed': "الملف ماترفعش",
  'camp.templateHeaderRequired': "مطلوب: القالب ده بيعرض الملف ده فوق الرسالة",
  'camp.okCreated': "تم إنشاء الحملة!",
  'camp.okUpdated': "تم تحديث الحملة",
  'camp.errCreate': "تعذّر إنشاء الحملة",
  'camp.errUpdate': "تعذّر تحديث الحملة",
  'camp.okFile': "تم رفع الملف!",
  'camp.okFileRemoved': "تم حذف الملف",
  'camp.errStatus': "تعذّر تغيير حالة الحملة",
  'camp.okDeleted': "تم حذف الحملة!",
  'camp.errDelete': "تعذّر حذف الحملة",
  'camp.okReport': "تم تنزيل التقرير!",
  'camp.errReport': "تعذّر تنزيل التقرير",
  'camp.errReportLoad': "تعذّر تحميل التقرير",
  'camp.connectionsHeader': "اتصالات الواتساب * ({count} مختار)",
  'camp.addMessageBtn': "+ رسالة",
  'fail.notOnWhatsApp': "الرقم غير مسجّل في واتساب",
  'fail.media': "تعذّر تحميل ملف الوسائط",
  'fail.credentials': "المزوّد رفض بيانات الدخول",
  'fail.timeout': "انتهت مهلة الاتصال",
  'fail.unsubscribed': "جهة الاتصال ألغت الاشتراك",
  'fail.unknown': "خطأ غير معروف",
  'fail.system': "خطأ في المنصّة — لم تُجرَّب الرسالة",

  // المستخدمون والاستيراد ونموذج جهة الاتصال
  'users.title': "المستخدمون",
  'users.search': "ابحث عن مستخدم...",
  'users.okCreated': "تم إنشاء المستخدم!",
  'users.okUpdated': "تم تحديث المستخدم!",
  'users.errUpdate': "تعذّر تحديث المستخدم",
  'users.okDeleted': "تم حذف المستخدم!",
  'users.errDelete': "تعذّر حذف المستخدم",
  'csv.title': "استيراد جهات الاتصال من CSV",
  'csv.subtitle': "استورد جهات اتصال كتير مرة واحدة",
  'csv.template': "ملف نموذج",
  'csv.templateHelp': "نزّل النموذج بالصيغة الصحيحة",
  'csv.download': "تنزيل",
  'csv.select': "اختار ملف CSV",
  'csv.clickSelect': "اضغط للاختيار",
  'csv.format': "الصيغة: .csv",
  'csv.total': "الإجمالي",
  'csv.succeeded': "نجحت",
  'csv.errors': "أخطاء",
  'csv.importing': "جارٍ الاستيراد...",
  'csv.import': "استيراد",
  'csv.errFile': "اختار ملف CSV صالح",
  'csv.errNoFile': "اختار ملف CSV",
  'csv.okTemplate': "تم تنزيل النموذج!",
  'csv.errTemplate': "تعذّر تنزيل النموذج",
  'form.name': "الاسم *",
  'form.namePlaceholder': "اكتب الاسم بالكامل",
  'form.phone': "الرقم *",
  'form.email': "الإيميل",
  'form.emailPlaceholder': "اكتب الإيميل",
  'form.category': "الفئة",
  'form.selectCategory': "اختار فئة",
  'form.loadingCategories': "جارٍ تحميل الفئات...",
  'form.notes': "ملاحظات",
  'form.notesPlaceholder': "اكتب ملاحظات إضافية",
  'form.consent': "موافق على استقبال الرسائل",
  'form.optedOut': "ألغى الاشتراك (لا يستقبل الحملات)",
  'form.perfexId': "معرّف العميل في Perfex",
  'form.perfexHelp': "جهة الاتصال هذه مستوردة من Perfex CRM",
  'form.saving': "جارٍ الحفظ...",
  'form.okUpdated': "تم تحديث جهة الاتصال",
  'form.okCreated': "تم إضافة جهة الاتصال",

  // الإعدادات والمستخدمون
  'users.empty': "لا يوجد مستخدمون",
  'users.colName': "الاسم",
  'users.colEmail': "الإيميل",
  'users.colRole': "الدور",
  'users.colStatus': "الحالة",
  'users.colLastLogin': "آخر دخول",
  'users.colActions': "إجراءات",
  'users.edit': "تعديل",
  'users.delete': "حذف",
  'users.formName': "الاسم",
  'users.formEmail': "الإيميل",
  'users.currentPassword': "كلمة المرور الحالية (مطلوبة لتغييرها)",
  'users.role': "الدور",
  'users.roleUser': "مستخدم",
  'users.roleAdmin': "مدير",
  'users.activeUser': "مستخدم نشط",
  'set.title': "الإعدادات",
  'set.subtitle': "اضبط إعدادات النظام",
  'set.loading': "جارٍ تحميل الإعدادات...",
  'set.configure': "ضبط",
  'set.remove': "حذف",
  'set.openaiDesc': "ChatGPT و GPT-4",
  'set.groqDesc': "LLaMA و Mixtral (سريعة جدًا)",
  'set.chatwootDesc': "منصة خدمة العملاء",
  'set.chatwootHelp': "اضبط تكامل Chatwoot لمزامنة المحادثات",
  'set.perfexDesc': "نظام إدارة العملاء والمشاريع",
  'set.signupTitle': "تسجيل العملاء",
  'set.signupHelp': "عند تفعيله، يستطيع أي شخص إنشاء حساب من صفحة التسجيل. يؤكّد رقمه برمز يُرسل من الاتصال الذي تختاره بالأسفل، ويبدأ بتجربة مجانية. أما الترقية إلى الباقات المدفوعة فتتم من لوحة إدارة المنصّة.",
  'set.signupAllow': "السماح للعملاء الجدد بالتسجيل",
  'set.signupConnection': "الاتصال الذي يُرسل الرمز",
  'set.signupConnectionHelp': "استخدم رقماً خاصاً بك، لا رقم عميل. ويجب أن يبقى متصلاً.",
  'set.signupSelect': "— اختر اتصالاً —",
  'set.trialDays': "مدة التجربة المجانية (أيام)",
  'set.signupSave': "حفظ إعدادات التسجيل",
  'set.signupSaved': "تم حفظ إعدادات التسجيل",
  'set.signupErrConnection': "اختر اتصال الواتساب الذي سيُرسل رمز التحقق",
  'set.policyTitle': "سياسة الإرسال المسؤول",
  'set.policyHelp': "هذه الحدود تساعدك على الإرسال بمسؤولية، لكنها لا تُغني عن موافقة العميل — أرسل لمن وافق على استقبال رسائلك.",
  'set.minInterval': "أقل فاصل بين الرسائل (ثانية)",
  'set.dailyLimit': "الحد اليومي لكل رقم",
  'set.windowStart': "نافذة الإرسال — البداية",
  'set.windowEnd': "نافذة الإرسال — النهاية",
  'set.windowHelp': "إذا كانت البداية بعد النهاية، فالنافذة تمتد إلى ما بعد منتصف الليل",
  'set.timezone': "المنطقة الزمنية",
  'set.timezoneHelp': "المنطقة الزمنية المستخدمة في نافذة الإرسال",
  'set.autoPause': "إيقاف تلقائي عند نسبة فشل (%)",
  'set.requireConsent': "اشتراط الموافقة",
  'set.requireConsentHelp': "الحملات تصل فقط لمن سُجّلت موافقتهم",
  'set.optOutKeywords': "كلمات إلغاء الاشتراك",
  'set.optOutMessage': "رسالة تأكيد إلغاء الاشتراك",
  'set.optOutPlaceholder': "اتركها فارغة لاستخدام الرسالة الافتراضية",
  'set.policySave': "حفظ سياسة الإرسال",
  'set.policySaved': "تم حفظ سياسة الإرسال",
  'set.policyErrSave': "تعذّر حفظ سياسة الإرسال",
  'set.errInterval': "الفاصل الأدنى لازم يكون بين 5 و3600 ثانية",
  'set.errDaily': "الحد اليومي لازم يكون بين 1 و10000",
  'set.errFailure': "نسبة الفشل لازم تكون بين 5 و100%",
  'set.errWindow': "اكتب بداية ونهاية نافذة الإرسال",
  'set.openaiKey': "مفتاح OpenAI",
  'set.openaiKeyHelp': "مفتاح API لاستخدام ChatGPT في الحملات",
  'set.groqKey': "مفتاح Groq",
  'set.claudeDesc': "Claude من Anthropic (ممتاز في العربي والكتابة التسويقية)",
  'set.claudeKey': "مفتاح Claude API",
  'set.claudeHelp': "اعمله من console.anthropic.com ← API Keys. بتستخدمه المتابعة الذكية.",
  'set.chatwootUrl': "رابط Chatwoot *",
  'set.chatwootUrlHelp': "الرابط الكامل لنسخة Chatwoot الخاصة بك",
  'set.accountId': "معرّف الحساب *",
  'set.accountIdHelp': "الرقم التعريفي لحساب Chatwoot",
  'set.apiToken': "رمز API *",
  'set.errLoad': "تعذّر تحميل الإعدادات",
  'set.okIntegration': "تم حفظ إعدادات التكامل",
  'set.errIntegration': "تعذّر حفظ إعدادات التكامل",
  'set.errRemoveIntegration': "تعذّر حذف التكامل",
  'set.okPerfex': "تم ضبط تكامل Perfex CRM",
  'set.errPerfex': "تعذّر ضبط Perfex CRM",
  'set.savePolicy': "حفظ السياسة",

  // شركتي
  'company.title': "شركتي",
  'company.subtitle': "باقتك واستهلاكك وفريقك",
  'company.plan': "الباقة",
  'company.status': "الحالة",
  'company.statusTrial': "تجربة مجانية",
  'company.statusActive': "مفعّلة",
  'company.statusSuspended': "موقوفة",
  'company.renews': "سارية حتى",
  'company.noExpiry': "بدون تاريخ انتهاء",
  'company.daysLeft': "فاضل {days} يوم",
  'company.expired': "منتهية",
  'company.ownerPhone': "رقم الحساب",
  'company.since': "عميل منذ",
  'company.usage': "الاستهلاك",
  'company.messagesMonth': "رسائل هذا الشهر",
  'company.contacts': "جهات الاتصال",
  'company.campaigns': "الحملات",
  'company.connections': "أرقام الواتساب",
  'company.users': "أعضاء الفريق",
  'company.unlimited': "بلا حدود",
  'company.ofLimit': "{used} من {limit}",
  'company.team': "الفريق",
  'company.manageUsers': "إدارة المستخدمين",
  'company.roleAdmin': "مدير",
  'company.roleUser': "عضو",
  'company.roleSuper': "مالك المنصة",
  'company.activeUser': "نشط",
  'company.inactiveUser': "غير نشط",
  'company.lastLogin': "آخر دخول",
  'company.never': "لم يدخل",
  'company.blocked': "الإرسال متوقف: {reason}",
  'company.upgradeHint': "تواصل معنا لترقية باقتك.",
  'company.errLoad': "تعذّر تحميل بيانات الشركة",
  'company.platformOwner': "أنت مسجّل كمالك للمنصّة. اختر شركة لعرض بياناتها.",
  'nav.company': "شركتي",
  'login.tagline': "منصة إدارة الحملات",
  'set.policyReadOnly': "هذه الحدود تحدّدها المنصّة للحفاظ على جودة الإرسال وسمعة رقمك. تنطبق على حسابك ولا يمكن تغييرها من هنا.",

  // لوحة المعلومات
  'nav.dashboard': "لوحة المعلومات",
  'dash.title': "لوحة المعلومات",
  'dash.subtitle': "أداء حملاتك ومحادثاتك",
  'dash.period7': "آخر 7 أيام",
  'dash.period30': "آخر 30 يوم",
  'dash.period90': "آخر 90 يوم",
  'dash.vsPrevious': "مقارنة بالفترة السابقة",
  'dash.noBaseline': "لا توجد بيانات سابقة",
  'dash.sent': "رسائل مُرسلة",
  'dash.delivery': "نسبة التسليم",
  'dash.deliverySub': "{delivered} من {sent} وصلت",
  'dash.read': "نسبة القراءة",
  'dash.readSub': "{read} من الرسائل التي وصلت قُرئت",
  'dash.reply': "نسبة الرد",
  'dash.replySub': "{people} ردّوا · {human} على الأرجح بشر",
  'dash.newContacts': "جهات اتصال جديدة",
  'dash.newContactsSub': "الإجمالي {total} جهة اتصال",
  'dash.unsubscribed': "ألغوا الاشتراك",
  'dash.unsubscribedSub': "{rate}% من الرسائل المُرسلة",
  'dash.failed': "فشلت",
  'dash.activity': "النشاط اليومي",
  'dash.legendSent': "مُرسلة",
  'dash.legendDelivered': "مُسلّمة",
  'dash.legendReplies': "ردود",
  'dash.noActivity': "لا يوجد نشاط في هذه الفترة",
  'dash.inbox': "صندوق الوارد",
  'dash.unread': "رسائل غير مقروءة",
  'dash.awaiting': "بانتظار ردّك",
  'dash.responseTime': "وسيط زمن الرد",
  'dash.answered': "تم الرد على {count} رسالة واردة",
  'dash.openInbox': "افتح صندوق الوارد",
  'dash.numbers': "أرقام الواتساب",
  'dash.sentToday': "{count} أُرسلت اليوم",
  'dash.receiving': "بيستقبل",
  'dash.notReceiving': "لا يستقبل",
  'dash.campaigns': "حملات الفترة",
  'dash.colCampaign': "الحملة",
  'dash.colSent': "مُرسلة",
  'dash.colDelivery': "التسليم",
  'dash.colRead': "القراءة",
  'dash.colFailed': "فشلت",
  'dash.viewAnalytics': "التفاصيل",
  'dash.noCampaigns': "لا توجد حملات في هذه الفترة",
  'dash.errLoad': "تعذّر تحميل لوحة المعلومات",
  'dash.ownerNote': "أنت مسجّل كمالك للمنصّة. افتح لوحة المنصّة لعرض الشركات.",
  'dash.minutes': "{count} دقيقة",
  'dash.hours': "{count} ساعة",
  'dash.seconds': "{count} ثانية",

  // تقرير الحملة
  'rep.title': "تقرير الحملة",
  'rep.refresh': "تحديث",
  'rep.export': "تنزيل Excel",
  'rep.analytics': "افتح التحليلات",
  'rep.progress': "التقدّم",
  'rep.progressOf': "{done} من {total} اتعالجت",
  'rep.createdBy': "أنشأها",
  'rep.createdAt': "الإنشاء",
  'rep.startedAt': "البدء",
  'rep.completedAt': "الانتهاء",
  'rep.connection': "الاتصال",
  'rep.statusRunning': "شغالة",
  'rep.statusPaused': "متوقفة",
  'rep.statusCompleted': "مكتملة",
  'rep.statusPending': "في الانتظار",
  'rep.statusScheduled': "مجدولة",
  'rep.kpiTotal': "المستلمين",
  'rep.kpiSent': "أُرسلت",
  'rep.kpiDelivered': "وصلت",
  'rep.kpiRead': "قُرئت",
  'rep.kpiFailed': "فشلت",
  'rep.kpiPending': "في الانتظار",
  'rep.kpiSkipped': "اتخطّت",
  'rep.ofSent': "من المُرسل",
  'rep.ofDelivered': "من المُسلّم",
  'rep.failures': "أسباب الفشل",
  'rep.noFailures': "لا يوجد فشل",
  'rep.bySession': "حسب الاتصال",
  'rep.notAssigned': "لم تُوزّع بعد",
  'rep.messages': "الرسائل",
  'rep.search': "ابحث بالاسم أو الرقم",
  'rep.filterAll': "الكل",
  'rep.colContact': "جهة الاتصال",
  'rep.colStatus': "الحالة",
  'rep.colDelivery': "التسليم",
  'rep.colSentAt': "وقت الإرسال",
  'rep.colDetails': "التفاصيل",
  'rep.msgSent': "أُرسلت",
  'rep.msgFailed': "فشلت",
  'rep.msgPending': "منتظرة",
  'rep.msgProcessing': "بتتبعت",
  'rep.msgSkipped': "اتخطّت",
  'rep.receiptSent': "وصلت لواتساب",
  'rep.receiptDelivered': "وصلت",
  'rep.receiptRead': "قُرئت",
  'rep.receiptNone': "بدون تأكيد بعد",
  'rep.empty': "لا توجد رسائل مطابقة",
  'rep.pageOf': "صفحة {page} من {pages}",
  'rep.showing': "{count} رسالة",
  'rep.errLoad': "تعذّر تحميل التقرير",
  'rep.okExport': "تم تنزيل التقرير",
  'rep.errExport': "تعذّر تنزيل التقرير",
  'rep.receiptsPending': "{count} رسالة مُرسلة بدون تأكيد حتى الآن",
  'rep.sysFailTitle': "{count} رسالة فشلت بسبب خطأ عندنا، مش بسبب الأرقام",
  'rep.sysFailBody': "الأرقام دي سليمة ولم تُرسَل لها أي محاولة فعلية. رجّعها للطابور وكمّل الحملة.",
  'rep.sysFailAction': "إرجاع للطابور",
  'rep.sysFailOk': "تم إرجاع {count} رسالة للطابور. شغّل الحملة لتكمل الإرسال.",
  'rep.sysFailErr': "تعذّر إرجاع الرسائل للطابور",
  'nav.platform': "المنصة",
  'sa.title': "نظرة عامة على المنصة",
  'sa.subtitle': "حالة الخدمة بالكامل الآن",
  'sa.refresh': "تحديث",
  'sa.manage': "إدارة الشركات",
  'sa.period14': "١٤ يوم",
  'sa.period30': "٣٠ يوم",
  'sa.period90': "٩٠ يوم",
  'sa.updated': "آخر تحديث {time}",
  'sa.errLoad': "تعذّر تحميل بيانات المنصة",
  'sa.kpiCompanies': "الشركات",
  'sa.kpiCompaniesSub': "{active} مشتركة · {trial} تجربة",
  'sa.kpiNew': "اشتراكات الشهر",
  'sa.kpiNewSub': "{count} خلال {days} يوم",
  'sa.kpiMessages': "رسائل الشهر",
  'sa.kpiMessagesSub': "{count} اليوم",
  'sa.kpiCapacity': "المستهلك من الطاقة الشهرية",
  'sa.kpiCapacitySub': "{used} من {total} مسموح بيها",
  'sa.kpiConnections': "أرقام واتساب",
  'sa.kpiConnectionsSub': "{connected} متصل · {offline} مفصول",
  'sa.kpiCampaigns': "حملات شغالة",
  'sa.kpiCampaignsSub': "{scheduled} مجدولة",
  'sa.statusActive': "مشتركة",
  'sa.statusTrial': "تجربة",
  'sa.statusExpired': "منتهية",
  'sa.statusSuspended': "موقوفة",
  'sa.attention': "محتاج تدخّل منك",
  'sa.attentionEmpty': "لا شيء يحتاج تدخّلاً الآن",
  'sa.attSUSPENDED': "الحساب موقوف",
  'sa.attTRIAL_ENDED': "التجربة خلصت",
  'sa.attTRIAL_ENDING': "التجربة تخلص خلال {days} أيام",
  'sa.attTRIAL_ENDING_1': "التجربة تخلص بكرة",
  'sa.attSUBSCRIPTION_ENDED': "الاشتراك انتهى",
  'sa.attSUBSCRIPTION_ENDING': "الاشتراك يخلص خلال {days} أيام",
  'sa.attSUBSCRIPTION_ENDING_1': "الاشتراك يخلص بكرة",
  'sa.attQUOTA_REACHED': "وصلت إلى حد الرسائل الشهري",
  'sa.attQUOTA_NEAR': "استهلكت {pct}% من حد الشهر",
  'sa.attNO_CONNECTION': "لا يوجد رقم واتساب متصل",
  'sa.plans': "الشركات حسب الباقة",
  'sa.planNoCompanies': "لا توجد شركات",
  'sa.planCompanies': "{count} شركات",
  'sa.planCompany': "شركة واحدة",
  'sa.planUnlimited': "من غير حد شهري",
  'sa.planLimit': "{count} رسالة/شهر",
  'sa.activity': "الحركة اليومية",
  'sa.legendSent': "أُرسلت",
  'sa.legendFailed': "فشلت",
  'sa.noActivity': "لا توجد رسائل في هذه الفترة",
  'sa.newCompanies': "{count} شركات جديدة",
  'sa.companies': "الشركات حسب الاستهلاك",
  'sa.colCompany': "الشركة",
  'sa.colPlan': "الباقة",
  'sa.colUsage': "استهلاك الشهر",
  'sa.colActivity': "المُرسل في {days} يوم",
  'sa.colConnections': "الأرقام",
  'sa.colLastSend': "آخر إرسال",
  'sa.never': "لا يوجد",
  'sa.unlimited': "من غير حد",
  'sa.billedNote': "المحسوب على الباقة: {count}",
  'sa.noCompanies': "لا توجد شركات بعد",
  'sa.totals': "{users} مستخدم · {contacts} جهة اتصال على المنصة",
  'dash.noNumbers': "لا يوجد رقم واتساب متصل بعد",
  'dash.connectNumber': "اربط رقمك",
  'dash.openPlatform': "افتح لوحة المنصة",
  'company.messagesDay': "رسائل اليوم",
  'sub.leftToday': "تبقّت لك {left} رسالة فقط اليوم.",
  'sub.usageToday': "{used} / {limit} اليوم",
  'landing.report.eyebrow': "تقارير الحملات",
  'landing.report.title': "تعرف نتيجة كل حملة بالأرقام",
  'landing.report.text': "بعد كل حملة تفتح تقريراً يوضّح كم رسالة وصلت وقُرئت، ومن ردّ عليك، وسبب كل رسالة لم تصل — ويمكن تنزيله كملف إكسل.",
  'landing.report.point1': "نسب التسليم والقراءة والرد لكل حملة",
  'landing.report.point2': "سبب واضح لكل رسالة لم تصل",
  'landing.report.point3': "قائمة بكل من تفاعل معك، جاهزة للمتابعة",
  'landing.report.campaign': "تقرير حملة عروض أكتوبر",
  'landing.report.progress': "اكتملت",
  'landing.report.deliveryRate': "نسبة التسليم",
  'landing.report.readRate': "نسبة القراءة",
  'landing.report.replyRate': "نسبة الرد",
  'landing.report.failures': "أسباب عدم الوصول",
  'landing.report.fail1': "الرقم غير مسجّل في واتساب",
  'landing.report.fail2': "تعذّر تحميل ملف الوسائط",
  'landing.report.repliers': "من ردّوا",
  'landing.report.reply1': "كم السعر؟",
  'landing.report.reply2': "أبغى أشوف العرض",
  'landing.report.reply3': "متى يوصل الطلب؟",
  'landing.report.minutes': "قبل {count} دقيقة",
  'landing.report.export': "تنزيل إكسل",
  'landing.contact.whatsapp': "تواصل معنا على واتساب",
  'landing.contact.prefill': "مرحباً، أريد معرفة المزيد عن منصّة تسويق واتساب.",
  'landing.contact.footer': "للاستفسار والدعم",
  'ob.title': "ابدأ من هنا",
  'ob.subtitle': "خمس خطوات تفصلك عن أول حملة ناجحة",
  'ob.progress': "{done} من {total} مكتملة",
  'ob.next': "الخطوة التالية",
  'ob.go': "ابدأ الخطوة",
  'ob.done': "تم",
  'ob.hide': "إخفاء الدليل",
  'ob.show': "دليل البداية",
  'ob.connection.title': "اربط رقم واتساب",
  'ob.connection.text': "امسح رمز QR مرة واحدة ليصبح الرقم جاهزاً للإرسال والاستقبال.",
  'ob.connection.action': "اذهب إلى الاتصالات",
  'ob.connection.doneText': "رقم متصل وجاهز",
  'ob.contacts.title': "أضف جهات اتصالك",
  'ob.contacts.text': "استورد ملف إكسل أو CSV، أو أضف الأرقام يدوياً، ورتّبها بالفئات.",
  'ob.contacts.action': "اذهب إلى جهات الاتصال",
  'ob.contacts.doneText': "{count} جهة اتصال",
  'ob.campaign.title': "أنشئ أول حملة",
  'ob.campaign.text': "اختر الفئة، واكتب الرسالة، وأرفق صورة أو ملف إن أردت.",
  'ob.campaign.action': "اذهب إلى الحملات",
  'ob.campaign.doneText': "{count} حملة",
  'ob.send.title': "أطلق الحملة وتابع الإرسال",
  'ob.send.text': "شغّل الحملة وراقب الأرقام وهي تتحرّك: أُرسلت، وصلت، قُرئت.",
  'ob.send.action': "شغّل حملتك",
  'ob.send.doneText': "{count} رسالة أُرسلت",
  'ob.inbox.title': "رُد على أول رسالة",
  'ob.inbox.text': "ردود عملائك تصل إلى صندوق الوارد — افتحها ورُد من المنصّة مباشرة.",
  'ob.inbox.action': "افتح صندوق الوارد",
  'ob.inbox.doneText': "{count} رسالة واردة",
  'ob.welcome.title': "أهلاً بك 👋",
  'ob.welcome.text': "حسابك جاهز. خمس خطوات قصيرة وتكون أرسلت أول حملة ورأيت نتيجتها بالأرقام.",
  'ob.welcome.start': "ابدأ الخطوة الأولى",
  'ob.welcome.later': "لاحقاً",
  'ob.banner.step': "الخطوة {index} من {total}",
  'ob.banner.finished': "أكملت خطوات البداية 🎉",
  'ob.banner.finishedText': "حسابك جاهز بالكامل. تقدر تراجع نتائج حملاتك من لوحة المعلومات في أي وقت.",
  'login.phone': "رقم الواتساب",
  'login.email': "البريد الإلكتروني",
  'login.useEmail': "الدخول بالبريد الإلكتروني بدلاً من ذلك",
  'login.usePhone': "الدخول برقم الواتساب بدلاً من ذلك",
  'login.blurb': "أدر جهات اتصالك وحملاتك على واتساب من مكان واحد.",
  'login.noAccount': "ليس لديك حساب؟",
  'login.contactUs': "تواصل معنا على واتساب",
  'login.contactPrefill': "مرحباً، أريد فتح حساب على منصّة تسويق واتساب.",
  'set.aiTitle': "تكاملات الذكاء الاصطناعي",
  'set.visibilityTitle': "ما تراه الشركات في هذه الصفحة",
  'set.visibilityHelp': "اختر التكاملات التي تظهر لعملائك. المغلقة تظل ظاهرة لك أنت فقط، ويمكن تشغيلها في أي وقت.",
  'set.visibilityAi': "إظهار تكاملات الذكاء الاصطناعي (OpenAI و Groq)",
  'set.visibilityChatwoot': "إظهار تكامل Chatwoot",
  'set.visibilityPerfex': "إظهار تكامل Perfex CRM",
  'set.visibilitySaved': "تم حفظ إعدادات الظهور",
  'set.errSave': "تعذّر حفظ الإعدادات",
  'set.aiHelp': "اضبط مفاتيح الواجهة البرمجية لاستخدام الذكاء الاصطناعي في الحملات",
  'set.chatwootTitle': "تكامل Chatwoot",
  'set.perfexTitle': "تكامل Perfex CRM",
  'set.perfexHelp': "اضبط تكامل Perfex CRM لمزامنة العملاء والفرص",
  'set.configured': "مضبوط",
  'set.notConfigured': "غير مضبوط",
  'dash.warmingUp': "فترة تسخين — اليوم {day}، الحد {limit} رسالة",
  'aud.title': "جمهور الحملة",
  'aud.subtitle': "من سيستلم هذه الحملة، ولماذا استُبعد الباقون",
  'aud.refresh': "إعادة الحساب",
  'aud.total': "إجمالي القائمة",
  'aud.eligible': "مؤهل للإرسال",
  'aud.validWhatsApp': "رقمه على واتساب",
  'aud.unknownWhatsApp': "لم يُفحص بعد",
  'aud.excludedTitle': "المستبعدون",
  'aud.engagementTitle': "درجة التفاعل",
  'aud.rulesTitle': "القواعد المطبَّقة",
  'aud.ruleCooldown': "فاصل {hours} ساعة بين حملتين لنفس العميل",
  'aud.ruleFrequency': "حد أقصى {count} حملات كل {days} يوم",
  'aud.ruleConsent': "الإرسال لمن سجّل موافقته فقط",
  'aud.noExclusions': "لا أحد مستبعَد — القائمة كلها مؤهلة",
  'aud.showList': "اعرض القائمة",
  'aud.hideList': "إخفاء القائمة",
  'aud.colContact': "جهة الاتصال",
  'aud.colReason': "سبب الاستبعاد",
  'aud.emptyList': "لا توجد جهات اتصال بهذا السبب",
  'aud.errLoad': "تعذّر تحميل تحليل الجمهور",
  'aud.at': "حُسب {time}",
  'ex.OPTED_OUT': "ألغى الاشتراك",
  'ex.SUPPRESSED': "في قائمة الحظر",
  'ex.INVALID_NUMBER': "الرقم غير مسجّل في واتساب",
  'ex.TEMP_FAILURE': "فشل مؤقت — سيُعاد لاحقًا",
  'ex.NO_CONSENT': "بدون موافقة مسجّلة",
  'ex.COOLDOWN': "وصلته حملة قريبًا",
  'ex.FREQUENCY_CAP': "تجاوز عدد الحملات المسموح",
  'eng.ENGAGED': "متفاعل (ردّ مؤخرًا)",
  'eng.ACTIVE': "نشط (وصلته حملة مؤخرًا)",
  'eng.INACTIVE': "خامل",
  'eng.NEW': "جديد",
  'hlt.title': "صحة الحملة",
  'hlt.sent': "أُرسلت",
  'hlt.delivered': "وصلت",
  'hlt.read': "قُرئت",
  'hlt.failed': "فشلت",
  'hlt.replied': "ردّوا",
  'hlt.optedOut': "ألغوا الاشتراك",
  'hlt.stoppedTitle': "الحملة متوقفة",
  'hlt.stopOPT_OUT_RATE': "توقفت لأن {optedOut} من {sent} طلبوا إيقاف الرسائل ({rate}%)، فوق الحد المسموح {limit}%.",
  'hlt.stopFAILURE_RATE': "توقفت لأن {failed} من {processed} فشلت ({rate}%)، فوق الحد المسموح {limit}%.",
  'hlt.stopDELIVERY_RATE': "توقفت لأن نسبة التسليم نزلت إلى {rate}%، تحت الحد الأدنى {limit}%.",
  'hlt.stopMANUAL': "أوقفها فريقك يدويًا.",
  'hlt.stopButton': "إيقاف الحملة الآن",
  'hlt.stopConfirm': "إيقاف الحملة؟ تقدر تكمّلها بعد المراجعة.",
  'hlt.stopped': "تم إيقاف الحملة",
  'hlt.errStop': "تعذّر إيقاف الحملة",
  'win.title': "مواعيد الإرسال",
  'win.help': "حدّد الفترات التي تُرسل فيها حملاتك خلال اليوم. تقدر تضيف أكثر من فترة — مثلاً الصباح ثم بعد العصر — والرسائل لا تخرج خارجها.",
  'win.period': "الفترة {number}",
  'win.from': "من",
  'win.to': "إلى",
  'win.add': "أضف فترة",
  'win.remove': "حذف",
  'win.save': "حفظ المواعيد",
  'win.saved': "تم حفظ مواعيد الإرسال",
  'win.errSave': "تعذّر حفظ المواعيد",
  'win.errSame': "وقت البداية والنهاية متطابقان في إحدى الفترات",
  'win.timezone': "بتوقيت {zone}",
  'common.saving': "جارٍ الحفظ…",
  'camp.ownSchedule': "مواعيد إرسال خاصة بهذه الحملة",
  'camp.ownScheduleHelp': "من غير تفعيل، الحملة تمشي على مواعيد الشركة المحدّدة في الإعدادات.",
  'conn.lastConnectedAs': "آخر رقم كان متصلاً:",
  'pc.title': "أرقام واتساب في كل الشركات",
  'pc.subtitle': "كل الاتصالات في مكان واحد — من متصل، ومن وقع، ومن لم يمسح الكود بعد",
  'pc.connected': "متصل",
  'pc.waitingQr': "بانتظار مسح الكود",
  'pc.offline': "غير متصل",
  'pc.colNumber': "الرقم",
  'pc.colCompany': "الشركة",
  'pc.colStatus': "الحالة",
  'pc.colInbox': "الوارد",
  'pc.colToday': "أُرسل اليوم",
  'pc.colLastSend': "آخر إرسال",
  'pc.noPhone': "لم يُربط بعد",
  'pc.empty': "لا توجد اتصالات على المنصّة",
  'pc.filterAll': "الكل",
  'pc.companySuspended': "شركة موقوفة",
  'pc.never': "لا يوجد",
  'pc.errLoad': "تعذّر تحميل الاتصالات",
  'sa.schemaTitle': "قاعدة البيانات متأخرة عن الكود",
  'sa.schemaHelp': "في جداول أو أعمدة ناقصة، وده بيخلّي بعض الشاشات ترجع خطأ ٥٠٠. التحديث بيتطبّق تلقائيًا عند إعادة تشغيل الخادم.",
};
